window.addEventListener("load", () => {
  class InquirySubmit {
    constructor() {
      this.generateHeaderFormBehaviour();
    }

    isPhoneValid(phone) {
      const re = /^(\+?1[\s-]*)?(\(?\d{3}\)?)[\s-]*(\d{3})[\s-]*(\d{4})(\s*x\d{1,5})?$/;
      return re.test(phone);
    }

    isEmailValid(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    validInput(target, buttonSubmit, formValid) {
      let value = target.value;
      let name = target.name;
      formValid[name] = (value !== '') ? value : '';
      if (name === 'email_address') formValid[name] = this.isEmailValid(value) ? value : '';
      if (name === 'phone_number') formValid[name] = this.isPhoneValid(value) ? value : '';
      if (formValid['phone_number'] !== '' && formValid['email_address'] !== '' && formValid['full_name'] !== '' && Object.keys(formValid).length >= 3) {
        buttonSubmit.disabled = false;
        buttonSubmit.classList.add("active");
      } else {
        buttonSubmit.disabled = true;
        buttonSubmit.classList.remove("active");
      }
    }
    generateHeaderFormBehaviour() {
      Array.from(document.querySelectorAll("#property-side-cta, #property-bottom-cta")).forEach(form => {
        let formValid = [];
        let buttonSubmit = form.querySelector(".property-cta-submit");
        let inputs = form.querySelectorAll(".property-cta");
        inputs.forEach(inputEl => {
          inputEl.addEventListener("keyup", e => this.validInput(e.target, buttonSubmit, formValid));
          inputEl.addEventListener("change", e => this.validInput(e.target, buttonSubmit, formValid));
        });

        form.addEventListener("submit", e => {
          e.preventDefault();
          this.submitInfo(form);
        });
      });
      jQuery('.cta-phone').mask("(999) 999-9999"), {autoclear: false};
      jQuery('.cta-phone--mobile').mask("(999) 999-9999"), {autoclear: false};
    }

    submitInfo(form) {
      document.getElementById(form.name + "-error").style.display = "none";
      var elements = form.elements;
      var formData = new FormData();
      var value = 0;
      for (var i = 0; i < elements.length; i++) {
        value = elements[i].value;
        if (elements[i].name.includes("phone")) {
          value = elements[i].value.replace(/[^\w\s]/gi, ""); // remove all special chars
          value = value.replace(/\s/g, ""); // remove all space
        }
        if (elements[i].name.includes("full_name")) {
          formData.append("first_name", elements[i].value.split(" ")[0]);
          formData.append("last_name", elements[i].value.split(" ")[1]);
          continue;
        }
        if (elements[i].value.includes("Request Info") || elements[i].name.includes("emailaddress")) {
          continue;
        }
        formData.append(elements[i].name, value);
      }

      formData.append("form_name", form.name);
      formData.append("browser", "User-agent header sent: " + navigator.userAgent);
      if (form.elements["emailaddress"].value == "") {
        var request = () => {
          return new Promise((resolve, reject) => {
            var xhr = this.caringPostRequest(resolve, reject);
            xhr.setRequestHeader("Caring-Partner", "50ad5e9ad994");
            xhr.setRequestHeader("Cache-Control", "no-cache, no-store, must-revalidate");
            xhr.setRequestHeader("Vary", "*");
            xhr.send(formData);
          });
        };

        request()
          .then(response => {
            document.getElementById(form.name + "-body").style.display = "none";
            document.getElementById(form.name + "-success").style.display = "block";
          })
          .catch(error => {
            if (document.querySelector("." + form.name + "-error-message"))
              document.querySelector("." + form.name + "-error-message").innerHTML = "";
            var newError = document.createElement("div");
            newError.setAttribute("class", form.name + "-error-message");
            if (error) {
              newError.textContent = JSON.parse(error)["error_message"];
              document.getElementById(form.name + "-error").firstElementChild.before(newError);
              document.getElementById(form.name + "-error").style.display = "block";
            } else {
              newError.textContent = "There was an unexpected error.";
              document.getElementById(form.name + "-error").firstElementChild.before(newError);
              document.getElementById(form.name + "-error").style.display = "block";
            }
          });
      } else {
        document.getElementById(form.name + "-body").style.display = "none";
        document.getElementById(form.name + "-success").style.display = "block";
      }
    }

    caringPostRequest(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", "https://dir.caring.com/api/v2/leads.json");
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 400 && xhr.readyState === 4) {
          resolve(xhr.response);
        } else {
          reject(xhr.responseText);
        }
      };
      xhr.onerror = () => reject(xhr.responseText);
      return xhr;
    }

    getCareType(ct) {
      var care_types = {
        "Alzheimer's Care": "alzheimers_care_facilities",
        "Assisted Living": "assisted_living_facilities",
        "Home Care": "homecare_agencies",
        "Independent Living": "independent_living",
      };
      if (care_types[ct]) {
        return care_types[ct];
      } else {
        return "assisted_living_facilities";
      }
    }
  }
  window.inquirySubmit = new InquirySubmit();
});
